import {
  clearFilteredView,
  createFilteredView,
  editFilteredView,
  fetchFilteredViews,
  fetchFilteredViewsByType,
  selectFilteredView,
} from '../routines/filteredViewsRoutines';
import { setMyEntitiesOnly } from '../routines';

const initialState = {
  myEntitiesOnly: false,
  isLoading: false,
  isSaving: false,
  isSavingError: false,
  selectedView: {
    organization: null,
    account: null,
    contact: null,
    pipeline: null,
    task: null,
    successplan: null,
  },
  list: {
    organization: [],
    account: [],
    contact: [],
    pipeline: [],
    task: [],
    successplan: [],
  },
  viewsLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case clearFilteredView.TRIGGER:
      return initialState;
    case selectFilteredView.TRIGGER:
      return {
        ...state,
        selectedView: {
          ...state.selectedView,
          [action.payload.type.toLowerCase()]: action.payload.id,
        },
      };
    case fetchFilteredViews.TRIGGER:
    case fetchFilteredViewsByType.TRIGGER: {
      return { ...state, viewsLoading: true };
    }

    case fetchFilteredViews.SUCCESS: {
      return {
        ...state,
        viewsLoading: false,
        list: action.payload.reduce(
          (acc, view) => {
            acc[view.type.toLowerCase()]?.push(view);
            return acc;
          },
          {
            organization: [],
            account: [],
            contact: [],
            pipeline: [],
            task: [],
            successplan: [],
          }
        ),
      };
    }
    case fetchFilteredViewsByType.SUCCESS: {
      return {
        ...state,
        viewsLoading: false,
        list: {
          ...state.list,
          [action.payload.type.toLowerCase()]: action.payload.filters,
        },
      };
    }

    case fetchFilteredViews.FAILURE:
    case fetchFilteredViewsByType.FAILURE:
      return {
        ...state,
        viewsLoading: false,
      };

    // create / edit filtered views
    case createFilteredView.TRIGGER:
    case editFilteredView.TRIGGER:
      return { ...state, isSaving: true, isSavingError: false };

    case createFilteredView.SUCCESS:
    case editFilteredView.SUCCESS:
      return { ...state, isSaving: false, isSavingError: false };

    case createFilteredView.FAILURE:
    case editFilteredView.FAILURE:
      return { ...state, isSaving: false, isSavingError: true };
    case setMyEntitiesOnly.TRIGGER:
      return {
        ...state,
        myEntitiesOnly: action.payload.myEntitiesOnly,
      };
    default:
      return state;
  }
};
